module.exports = __webpack_public_path__ + "static/media/solero-logo.f3eac6b8.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/page/parallaxBasic/solero-logo.png
// module id = 98
// module chunks = 0